var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBathroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M111.5,137.2c-6.2,0-11.3-5.1-11.3-11.3c0-5.6,8.1-14.2,9.7-15.9l1.5-1.6l1.5,1.6c1.6,1.7,9.7,10.3,9.7,15.9 C122.7,132.2,117.7,137.2,111.5,137.2z M111.5,114.8c-3.3,3.7-6.9,8.7-6.9,11.2c0,3.8,3.1,6.9,6.9,6.9s6.9-3.1,6.9-6.9 C118.4,123.5,114.7,118.4,111.5,114.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52.8,137.2c-6.2,0-11.3-5.1-11.3-11.3c0-5.6,8.1-14.2,9.7-15.9l1.5-1.6l1.5,1.6c1.6,1.7,9.7,10.3,9.7,15.9 C64.1,132.2,59.1,137.2,52.8,137.2z M52.8,114.8c-3.3,3.7-6.9,8.7-6.9,11.2c0,3.8,3.1,6.9,6.9,6.9s6.9-3.1,6.9-6.9 C59.8,123.5,56.1,118.4,52.8,114.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M86.5,153.6c-5.6,0-10.1-4.5-10.1-10.1c0-5,7.2-12.6,8.6-14.1l1.5-1.6l1.5,1.6c1.4,1.5,8.6,9.1,8.6,14.1 C96.6,149.1,92.1,153.6,86.5,153.6z M86.5,134.1c-2.8,3.2-5.8,7.4-5.8,9.4c0,3.2,2.6,5.8,5.8,5.8s5.8-2.6,5.8-5.8 C92.3,141.5,89.3,137.2,86.5,134.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M143.3,103.1H25.9c-2.1,0-3.8-1.7-3.8-3.8l0-0.9c0-36,25.7-61.1,62.5-61.1s62.5,25.1,62.5,61.1l0,0.6 C147,101.1,145.4,103.1,143.3,103.1z M29.7,95.5h109.8C138,65,116.3,44.9,84.6,44.9C52.8,44.9,31,65.1,29.7,95.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M179.1,200h-7.6V44.8c0-21.3-22.2-37.2-42.1-37.2h-1.6c-17.4,0-39.4,14-39.4,29.7v4.3h-7.6v-4.3c0-20.1,25.8-37.3,47-37.3 h6.5c0.7,0,1.3,0.2,1.9,0.5c21.4,3.2,42.9,21.1,42.9,44.2V200z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.9,
    y: 83.5,
    width: 109.9,
    height: 4.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathroom);
export default __webpack_public_path__ + "static/media/bathroom.b0e5fc73fd8b690f6abfa3b11ba65807.svg";
export { ForwardRef as ReactComponent };